import React, { Component } from "react";
import { Select, InputNumber, Input, Empty } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { ButtonItem, SelectEmpleadosItem } from "../../../../Components/Items";
import { formatoMoneda } from "../cmmsComun";

const { Option } = Select;

// Viaticos del servicio: solo informativos (no generan gasto ni poliza). Se suman en el
// reporte "Viáticos de los servicios". Se pueden capturar aun con el servicio concluido.
// value: [{ _id?, categoria, monto, descripcion, empleadoId }]
class ViaticosServicio extends Component {
    cambiar = (i, cambios) => this.props.onChange((this.props.value || []).map((v, j) => (j === i ? { ...v, ...cambios } : v)));

    agregar = () => {
        const categorias = this.props.categorias || [];
        this.props.onChange([...(this.props.value || []), { categoria: categorias[0] || "", monto: null, descripcion: "", empleadoId: null }]);
    };

    quitar = (i) => this.props.onChange((this.props.value || []).filter((_, j) => j !== i));

    render() {
        const lista = this.props.value || [];
        const { disabled } = this.props;
        const total = lista.reduce((a, v) => a + (Number(v.monto) || 0), 0);
        const categorias = [...new Set([...(this.props.categorias || []), ...lista.map((v) => v.categoria).filter(Boolean)])];
        return (
            <div>
                <div className="cmms-ayuda">Hospedaje, alimentos, casetas... Son informativos: no generan gasto ni póliza, sólo se suman en el reporte de viáticos.</div>
                {!lista.length ? (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin viáticos" style={{ margin: "8px 0" }} />
                ) : (
                    <div className="cmms-viaticos">
                        <div className="cmms-viaticos-fila cmms-viaticos-encabezado">
                            <span>Categoría</span>
                            <span>Monto</span>
                            <span>Descripción</span>
                            <span>Ingeniero</span>
                            <span />
                        </div>
                        {lista.map((v, i) => (
                            <div className="cmms-viaticos-fila" key={v._id || `n${i}`}>
                                <Select value={v.categoria || undefined} placeholder="Categoría" disabled={disabled} onChange={(categoria) => this.cambiar(i, { categoria })}>
                                    {categorias.map((c) => (
                                        <Option key={c} value={c}>
                                            {c}
                                        </Option>
                                    ))}
                                </Select>
                                <InputNumber
                                    value={v.monto}
                                    min={0}
                                    placeholder="$ 0.00"
                                    style={{ width: "100%" }}
                                    disabled={disabled}
                                    formatter={(x) => (x !== undefined && x !== null && x !== "" ? `$ ${x}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "")}
                                    parser={(x) => x.replace(/\$\s?|(,*)/g, "")}
                                    onChange={(monto) => this.cambiar(i, { monto })}
                                />
                                <Input value={v.descripcion} maxLength={300} placeholder="Opcional" disabled={disabled} onChange={(e) => this.cambiar(i, { descripcion: e.target.value })} />
                                <SelectEmpleadosItem
                                    empresaId={this.props.empresaId}
                                    headersToken={this.props.headersToken}
                                    width="100%"
                                    placeholder="El del servicio"
                                    allowClear
                                    value={v.empleadoId || undefined}
                                    disabled={disabled}
                                    onChange={(empleadoId) => this.cambiar(i, { empleadoId: empleadoId || null })}
                                />
                                {!disabled ? <ButtonItem type="default" htmlType="button" rojo lessTime icon={<DeleteOutlined />} onClick={() => this.quitar(i)} /> : <span />}
                            </div>
                        ))}
                        <div className="cmms-viaticos-total">
                            Total: <b>{formatoMoneda(total)}</b>
                        </div>
                    </div>
                )}
                {!disabled && (
                    <ButtonItem type="dashed" htmlType="button" blanco lessTime icon={<PlusOutlined />} onClick={this.agregar}>
                        Agregar viático
                    </ButtonItem>
                )}
            </div>
        );
    }
}

export default ViaticosServicio;
